import gql from 'graphql-tag'
import createQuery from 'legacy/apollo/createQuery'

export const deliveryHoursQuery = gql`
  query locationDeliveryHours($id: ID!, $dates: [Date!]!) {
    warehouseLocation(id: $id) {
      deliveryHours(dates: $dates) {
        date
        endsAtHour
        startsAtHour
      }
    }
  }
`

export interface LocationDeliveryHours {
  date: string
  startsAtHour: number
  endsAtHour: number
}

export interface LocationDeliveryHoursVariables {
  id: string
  dates: string[]
}

export interface LocationDeliveryHoursData {
  warehouseLocation: {
    deliveryHours: LocationDeliveryHours[]
  }
}

export const locationDeliveryHoursQuery = createQuery<
  LocationDeliveryHoursData,
  LocationDeliveryHoursVariables
>(deliveryHoursQuery)
